var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76004 10.6998V5.84621L8.00004 8.67288L12.24 5.84621V10.6998C12.24 10.8521 12.0934 11.0398 11.84 11.0398H4.16004C3.90672 11.0398 3.76004 10.8521 3.76004 10.6998Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 7.32681L4.44959 4.95984H11.5505L8.00004 7.32681Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8 16C14.5673 16 16 14.5673 16 12.8V3.2C16 1.43269 14.5673 0 12.8 0H3.2C1.43269 0 0 1.43269 0 3.2V12.8C0 14.5673 1.43269 16 3.2 16H12.8ZM2.64004 5.35984C2.64004 4.52037 3.32057 3.83984 4.16004 3.83984H11.84C12.6795 3.83984 13.36 4.52037 13.36 5.35984V10.6998C13.36 11.5376 12.6427 12.1598 11.84 12.1598H4.16004C3.35735 12.1598 2.64004 11.5376 2.64004 10.6998V5.35984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLight);
export default __webpack_public_path__ + "static/media/email_light.236c741338cbf80cfa26aed747aa99ca.svg";
export { ForwardRef as ReactComponent };